import { useSelector } from 'react-redux';
import { UserProfile } from '@trnsact/trnsact-shared-types';

import { REPORT_FILTERS } from '../constants';
import { VendorContactRoles } from '../../../types';

export function useStagesReportDefaultFilters() {
  const userProfile = useSelector<any, UserProfile>(state => state.userProfile);

  if (userProfile.vendorContactRole === VendorContactRoles.SalesRep) {
    return {
      initialFilters: {
        ...REPORT_FILTERS,
        salesPersonId: userProfile.id,
      },
    };
  }

  return { initialFilters: REPORT_FILTERS };
}
